module.exports = "https://static.web-explore.prod.greetz-nl.net/_next/static/images/logo-square-win8-ff248c872dd908af98c1c750b745f44c.png";